module.exports = __webpack_public_path__ + "img/Flag_of_Ukraine.627ef713.svg";